<div class="modal-header">
    <h4 *ngIf="!clockEmpty && clockStatus.ClockAction">You are currently clocked-in</h4>
    <h4 *ngIf="clockEmpty || !clockStatus.ClockAction">You are currently clocked-out</h4>
</div>
<div class="modal-body">
    <div *ngIf="alert != null" class="alert alert-danger">
        {{alert}}
        <button type="button" class="close" (click)="closeAlert()" style="font-size: 1rem;" *ngIf="isTripExist">
            <span class="oi oi-x"></span>
        </button>
    </div>
    <div class="card row" style="display:block;margin-bottom:15px;" *ngIf="!clockEmpty && clockStatus.ClockAction && isTripExist">
        <div style="margin-left: 15px;">
            <label style="font-size:.8em;">Work Order</label><br />
            {{clockStatus.WorkOrder}} - {{clockStatus.WorkOrderDescription}}
        </div><hr style="margin-top:5px;margin-bottom:5px;" />
        <div style="margin-left: 15px;">
            <label style="font-size:.8em;">Scope</label><br />
            {{clockStatus.Scope}} - {{clockStatus.ScopeDescription}}
        </div><hr style="margin-top:5px;margin-bottom:5px;" />
        <div style="margin-left: 15px;">
            <label style="font-size:.8em;">Clocked-In Time</label><br />
            {{clockStatus.ClockDateDisplay}} {{clockStatus.ClockTimeDisplay}}
        </div><hr style="margin-top:5px;margin-bottom:5px;" />
        <div style="margin-left: 15px;">
            <label style="font-size:.8em;">Pay Type</label><br />
            {{clockStatus.PayTypeDescription}}
        </div>
    </div>
    <div class="card row" style="display:block;margin-bottom:15px;" *ngIf="clockEmpty || (!clockStatus.ClockAction)">
        <div style="margin-left: 15px;">
            <span *ngIf="!clockStatus.ClockAction">Navigate to a scope to clock-in.</span>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-text-primary" (click)="cancelClicked()">Close</button>
    <button type="button" class="btn btn-primary" (click)="clockOutClicked()" *ngIf="!clockEmpty && clockStatus.ClockAction && isTripExist">Clock Out</button>
</div>